import { Row, Col, Card, Button, Container } from "react-bootstrap";
import { BsPersonVcard, BsCashStack, BsBuildings, BsArrowRightCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const SalesDashboard = () => {
  const navigate = useNavigate();

  const brandPrimary = "#66C15E";
  const brandLight = "#ebf5ea";

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };
  
  const [firstName, setFirstName] = useState(localStorage.getItem("name") || "Sales Person");

  useEffect(() => {
    const handleProfileUpdate = () => {
      setFirstName(localStorage.getItem("name") || "Sales Person");
    };
    window.addEventListener("profile_updated", handleProfileUpdate);
    return () => window.removeEventListener("profile_updated", handleProfileUpdate);
  }, []);

  return (
    <div className="page-content" style={{ minHeight: "calc(100vh - 70px)", background: "linear-gradient(135deg, #f8f9fa 0%, #eef2f5 100%)", padding: "40px 20px" }}>
      <Container fluid>
        <div className="mb-4 text-start">
          <h4 className="fw-semibold text-muted mb-0">
            {getGreeting()}, <span style={{ color: brandPrimary }}>{firstName}</span> 👋
          </h4>
        </div>

        <div className="text-center mb-5">
          <h2 className="fw-bold" style={{ color: "#2c3e50" }}>Welcome to the Registration Hub</h2>
          <p className="text-muted fs-5">Select a category below to initiate a new registration.</p>
        </div>

        <Row className="justify-content-center g-4">
          <Col lg={4} md={4} sm={12} xs={12} className="mb-4">
            <Card
              className="h-100 text-center border-0 shadow-sm"
              style={{ cursor: "pointer", transition: "all 0.3s ease", borderRadius: "16px", overflow: "hidden" }}
              onClick={() => navigate("/sales/register-entrepreneur")}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-10px)"; e.currentTarget.style.boxShadow = "0 1rem 3rem rgba(0,0,0,.175)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)"; }}
            >
              <div style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, height: "80px" }}></div>
              <Card.Body className="px-4 pb-4 pt-0 position-relative d-flex flex-column">
                <div className="d-flex justify-content-center mb-3" style={{ marginTop: "-40px" }}>
                  <div className="d-flex justify-content-center align-items-center rounded-circle bg-white shadow" style={{ width: 80, height: 80 }}>
                    <BsBuildings size={35} style={{ color: brandPrimary }} />
                  </div>
                </div>
                <Card.Title className="fw-bold fs-4 mb-3">Entrepreneur</Card.Title>
                <Card.Text className="text-muted mb-4" style={{ minHeight: "48px" }}>
                  Register a new business seeking investment, growth, or sale opportunities.
                </Card.Text>
                <Button className="mt-auto w-100 rounded-pill py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 text-white" style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, border: "none" }}>
                  Register Now <BsArrowRightCircle size={18} />
                </Button>
              </Card.Body>
            </Card>
          </Col>



          <Col lg={4} md={4} sm={12} xs={12} className="mb-4">
            <Card
              className="h-100 text-center border-0 shadow-sm"
              style={{ cursor: "pointer", transition: "all 0.3s ease", borderRadius: "16px", overflow: "hidden" }}
              onClick={() => navigate("/sales/register-investor")}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-10px)"; e.currentTarget.style.boxShadow = "0 1rem 3rem rgba(0,0,0,.175)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)"; }}
            >
              <div style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, height: "80px" }}></div>
              <Card.Body className="px-4 pb-4 pt-0 position-relative d-flex flex-column">
                <div className="d-flex justify-content-center mb-3" style={{ marginTop: "-40px" }}>
                  <div className="d-flex justify-content-center align-items-center rounded-circle bg-white shadow" style={{ width: 80, height: 80 }}>
                    <BsCashStack size={35} style={{ color: brandPrimary }} />
                  </div>
                </div>
                <Card.Title className="fw-bold fs-4 mb-3">Investor</Card.Title>
                <Card.Text className="text-muted mb-4" style={{ minHeight: "48px" }}>
                  Register an individual or institutional investor looking for opportunities.
                </Card.Text>
                <Button className="mt-auto w-100 rounded-pill py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 text-white" style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, border: "none" }}>
                  Register Now <BsArrowRightCircle size={18} />
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12} className="mb-4">
            <Card
              className="h-100 text-center border-0 shadow-sm"
              style={{ cursor: "pointer", transition: "all 0.3s ease", borderRadius: "16px", overflow: "hidden" }}
              onClick={() => navigate("/sales/register-mentor")}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-10px)"; e.currentTarget.style.boxShadow = "0 1rem 3rem rgba(0,0,0,.175)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 .125rem .25rem rgba(0,0,0,.075)"; }}
            >
              <div style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, height: "80px" }}></div>
              <Card.Body className="px-4 pb-4 pt-0 position-relative d-flex flex-column">
                <div className="d-flex justify-content-center mb-3" style={{ marginTop: "-40px" }}>
                  <div className="d-flex justify-content-center align-items-center rounded-circle bg-white shadow" style={{ width: 80, height: 80 }}>
                    <BsPersonVcard size={35} style={{ color: brandPrimary }} />
                  </div>
                </div>
                <Card.Title className="fw-bold fs-4 mb-3">Mentor</Card.Title>
                <Card.Text className="text-muted mb-4" style={{ minHeight: "48px" }}>
                  Onboard an expert mentor to provide strategic guidance and networking.
                </Card.Text>
                <Button className="mt-auto w-100 rounded-pill py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 text-white" style={{ background: `linear-gradient(135deg, #8ad783 0%, ${brandPrimary} 100%)`, border: "none" }}>
                  Register Now <BsArrowRightCircle size={18} />
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SalesDashboard;
